import { useFormContext } from "react-hook-form";
import CompanyTypesCheckboxes from "$forms/CompanyTypesCheckboxes/CompanyTypesCheckboxes";
import CField from "$forms/CField";
import { CompanyType } from "$types/CompanyType";
import { getCompanyTypeLabel } from "$utils/typeConstants";
import { Alert } from "$components";
import { Company } from "$types";
import { Loader } from "$components/Layout/Loader";
import useCompanyTypes from "../hooks/useCompanyTypes";

type Props = {
  companyId?: Company["_id"];
  initialCompanyTypes: CompanyType[];
  isReadOnly: boolean;
};

function CompanyTypes({ companyId, initialCompanyTypes, isReadOnly }: Props) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const {
    isLoading,
    hasOneOpInActiveShipment,
    disabledCompanyTypes,
    hasLostSupplier,
    hasLostContributor,
    hasLostClient,
    TYPE_WARNING_MESSAGES,
  } = useCompanyTypes({ companyId, initialCompanyTypes, isReadOnly });

  if (isLoading) {
    return <Loader />;
  }

  const disabledMessage = `Un seul type d'entreprise peut être sélectionné à la fois, sauf "${getCompanyTypeLabel(
    CompanyType.CLIENT
  )}" et "${getCompanyTypeLabel(
    CompanyType.CONTRIBUTOR
  )}", ou "${getCompanyTypeLabel(
    CompanyType.CLIENT
  )}" et "${getCompanyTypeLabel(CompanyType.SUPPLIER)}".`;

  return (
    <CField
      control={control}
      name="companyTypes"
      required
      error={errors.companyTypes}
      rules={{
        required: "Veuillez sélectionner un type d'entreprise",
      }}
      label="Type d'entreprise"
      disabled={isReadOnly}
    >
      {(props) => (
        // @todo: can make a single multi checkbox component for activites and company types
        <>
          <CompanyTypesCheckboxes
            clientDisabledMessage={
              hasOneOpInActiveShipment &&
              "Ce client a des OP embarqués dans un ou plusieurs dossiers."
            }
            disabledCompanyTypes={disabledCompanyTypes}
            disabledMessage={disabledMessage}
            {...props}
          />
          {hasLostSupplier && (
            <Alert severity="warning" style={{ maxWidth: "800px" }}>
              {TYPE_WARNING_MESSAGES.lostSupplier}
            </Alert>
          )}
          {hasLostContributor && (
            <Alert severity="warning" style={{ maxWidth: "800px" }}>
              {TYPE_WARNING_MESSAGES.lostContributor}
            </Alert>
          )}
          {hasLostClient && (
            <Alert severity="warning" style={{ maxWidth: "800px" }}>
              {TYPE_WARNING_MESSAGES.lostClient}
            </Alert>
          )}
        </>
      )}
    </CField>
  );
}

export default CompanyTypes;
